// ATL Customize Tour - Simple, readable, no module syntax
;(function(w, d){
	var FORM_SELECTOR = '#atl-customize-tour-form';
	var BUTTON_SELECTOR = '#atl-customize-tour-submit-btn';
	var BLOCKED_TRAVELLERS_NOTICE = '<p>We couldn’t complete your request right now. Please try again later.</p>';

	/** Nội dung thông báo chặn submit (HTML từ Theme Options): ưu tiên Theme Options, fallback mặc định. */
	function getBlockedMessage() {
		var configured = (w.atlConfigAjax && w.atlConfigAjax.submission_blocked_message)
			? String(w.atlConfigAjax.submission_blocked_message).trim()
			: '';
		return configured || BLOCKED_TRAVELLERS_NOTICE;
	}

	function init() {
		var form = d.querySelector(FORM_SELECTOR);
		if (!form) return;
		bindConditionalFields(form);
		form.addEventListener('submit', handleSubmit);
		attachLiveFieldValidation(form);
		applyQuickRequestPrefill(form);
	}

	function handleSubmit(event) {
		event.preventDefault();
		var form = event.target;
		var submitBtn = form.querySelector(BUTTON_SELECTOR);

		clearErrors(form);

		var errors = validate(form);
		if (Object.keys(errors).length) {
			renderErrors(form, errors);
			return;
		}

		// Chặn submit khi số khách là 1 người — check sau cùng, khi mọi trường đã hợp lệ.
		if (isBlockedTravellersCount(form)) {
			showBlockedNotice(form);
			return;
		}

		setButtonLoading(submitBtn, true);
		setOverlay(form, true);

		send(form)
			.then(function(response){
				setButtonLoading(submitBtn, false);

				if (response.success) {
					var phoneInput = form.querySelector('#atl-phone-input');
					var normalizedPhone = (w.atlGetPhoneE164ForTracking && phoneInput)
						? w.atlGetPhoneE164ForTracking(phoneInput)
						: (form.querySelector('[name="phone"]') ? form.querySelector('[name="phone"]').value : '');
					// Store form data before showing success for Google Analytics tracking
					var formDataForTracking = {
						email: form.querySelector('[name="email"]') ? form.querySelector('[name="email"]').value : '',
						phone: normalizedPhone
					};

					showSuccess(form);

					// Google Analytics tracking with booking_id and total_value from response
					var bookingId = response.data && response.data.booking_id ? response.data.booking_id : null;
					var totalValue = response.data && response.data.total_value ? response.data.total_value : 0;
					trackGoogleAnalytics(bookingId, formDataForTracking, totalValue);
					
					return;
				}

				setOverlay(form, false);
				if (response.data && response.data.blocked) {
					showBlockedNotice(form, response.data.message);
					return;
				}

				renderErrors(form, response.data.errors || {}, response.data.message);
			})
			.catch(function(){
				setButtonLoading(submitBtn, false);
				setOverlay(form, false);
				renderErrors(form, {}, 'Something went wrong. Please try again.');
			});
	}

	function validate(form) {
		var errors = {};
		var required = [
			{ name: 'travellers', label: 'Number of travellers' },
			{ name: 'days', label: 'Number of days' },
			{ name: 'hotel_category', label: 'Hotel Category' },
			{ name: 'travel_date', label: 'Travel date' },
			{ name: 'full_name', label: 'Full name' },
			{ name: 'email', label: 'Email' },
			{ name: 'confirm_email', label: 'Confirm email' },
			{ name: 'phone', label: 'Phone number' },
			{ name: 'nationality', label: 'Nationality' },
			{ name: 'agent_type', label: 'Are you Travel Agent?' }
		];

		required.forEach(function(field){
			var input = form.querySelector('[name="' + field.name + '"]');
			if (!input || !input.value.trim()) {
				errors[field.name] = field.label + ' is required.';
			}
		});

		var travellers = form.querySelector('[name="travellers"]');
		var customTravellers = form.querySelector('[name="travellers_custom"]');
		var selectedRange = travellers ? travellers.value : '';
		if (isLargeTravellersRange(selectedRange)) {
			var range = getTravellersRange(selectedRange);
			var customValue = customTravellers ? parseInt(customTravellers.value, 10) : NaN;
			if (!customTravellers || !customTravellers.value.trim()) {
				errors['travellers_custom'] = 'Please enter exact number of travellers.';
			} else if (Number.isNaN(customValue) || customValue < range.min || customValue > range.max) {
				errors['travellers_custom'] = 'Number of travellers must be between ' + range.min + ' and ' + range.max + '.';
			}
		}

		if (w.ATLValidation) {
			w.ATLValidation.checkNameField(form, 'full_name', 'Full name', errors);
			w.ATLValidation.checkNameField(form, 'company_name', 'Company name', errors, true);
			w.ATLValidation.checkEmailField(form, 'email', errors);
		}

		var email = form.querySelector('[name="email"]');

		var confirm = form.querySelector('[name="confirm_email"]');
		if (email && confirm && email.value !== confirm.value) {
			errors['confirm_email'] = 'Email addresses do not match.';
		}

		var agentType = form.querySelector('[name="agent_type"]');
		var companyName = form.querySelector('[name="company_name"]');
		if (agentType && requiresCompanyName(agentType.value)) {
			if (!companyName || !companyName.value.trim()) {
				errors['company_name'] = getCompanyNameLabel(agentType.value) + ' is required.';
			}
		}

		var guideChecked = form.querySelectorAll('input[name="guide_languages[]"]:checked');
		if (!guideChecked.length) {
			errors['guide_languages'] = 'Please select at least one guide language.';
		}

		var travelDateInput = form.querySelector('[name="travel_date"]');
		if (travelDateInput && travelDateInput.value.trim()) {
			var minTravelDate = new Date();
			minTravelDate.setHours(0, 0, 0, 0);
			minTravelDate.setDate(minTravelDate.getDate() + 3);

			var selectedDate = null;
			if (travelDateInput._atlPikaday && typeof travelDateInput._atlPikaday.getDate === 'function') {
				selectedDate = travelDateInput._atlPikaday.getDate();
			}
			if (!selectedDate) {
				selectedDate = new Date(travelDateInput.value);
			}
			if (!(selectedDate instanceof Date) || isNaN(selectedDate.getTime())) {
				errors['travel_date'] = 'Please select a valid travel date.';
			} else {
				selectedDate.setHours(0, 0, 0, 0);
				if (selectedDate < minTravelDate) {
					errors['travel_date'] = 'Travel date must be at least 3 days from today.';
				}
			}
		}

		return errors;
	}

	function bindConditionalFields(form) {
		var travellers = form.querySelector('#atl-travellers-select');
		var agentType = form.querySelector('#atl-agent-type-select');
		if (travellers) {
			travellers.addEventListener('change', function(){
				toggleTravellersCustomInput(form);
			});
			toggleTravellersCustomInput(form);
		}
		if (agentType) {
			agentType.addEventListener('change', function(){
				toggleCompanyNameInput(form);
			});
			toggleCompanyNameInput(form);
		}
	}

	function getTravellersCount(form) {
		var travellers = form.querySelector('[name="travellers"]');
		var value = travellers ? String(travellers.value).trim() : '';
		if (isLargeTravellersRange(value)) {
			var custom = form.querySelector('[name="travellers_custom"]');
			value = custom ? String(custom.value).trim() : '';
		}
		var parsed = parseInt(value, 10);
		return Number.isNaN(parsed) ? 0 : parsed;
	}

	function isBlockedTravellersCount(form) {
		return getTravellersCount(form) === 1;
	}

	function isLargeTravellersRange(value) {
		return value === '31-50' || value === '51-100' || value === '100+';
	}

	function getTravellersRange(value) {
		if (value === '31-50') return { min: 31, max: 50 };
		if (value === '51-100') return { min: 51, max: 100 };
		if (value === '100+') return { min: 101, max: 10000 };
		return null;
	}

	function toggleTravellersCustomInput(form) {
		var travellers = form.querySelector('#atl-travellers-select');
		var wrapper = form.querySelector('#atl-travellers-custom-group');
		var input = form.querySelector('#atl-travellers-custom');
		if (!travellers || !wrapper || !input) return;

		var range = getTravellersRange(travellers.value);
		if (!range) {
			wrapper.style.display = 'none';
			input.required = false;
			input.value = '';
			clearFieldError(form, 'travellers_custom');
			return;
		}

		wrapper.style.display = 'block';
		input.required = true;
		input.min = String(range.min);
		input.max = String(range.max);
		input.placeholder = 'Enter number from ' + range.min + ' to ' + range.max;
	}

	function requiresCompanyName(agentTypeValue) {
		return agentTypeValue === 'agency' || agentTypeValue === 'corporate' || agentTypeValue === 'school';
	}

	function getCompanyNameLabel(agentTypeValue) {
		if (agentTypeValue === 'agency') return 'Company/Agency name';
		if (agentTypeValue === 'corporate') return 'Company name';
		if (agentTypeValue === 'school') return 'School name';
		return 'Company/Agency name';
	}

	function toggleCompanyNameInput(form) {
		var agentType = form.querySelector('#atl-agent-type-select');
		var wrapper = form.querySelector('#atl-company-name-group');
		var input = form.querySelector('#atl-company-name-input');
		var label = form.querySelector('#atl-company-name-label');
		if (!agentType || !wrapper || !input || !label) return;

		if (!requiresCompanyName(agentType.value)) {
			wrapper.style.display = 'none';
			input.required = false;
			input.value = '';
			clearFieldError(form, 'company_name');
			return;
		}

		wrapper.style.display = 'block';
		input.required = true;
		label.textContent = getCompanyNameLabel(agentType.value);
	}

	function applyQuickRequestPrefill(form) {
		var rawPrefill = '';
		try {
			rawPrefill = sessionStorage.getItem('atl_quick_request_prefill');
		} catch (e) {
			console.warn('Cannot read quick request prefill', e);
			return;
		}
		if (!rawPrefill) return;

		var payload = {};
		try {
			payload = JSON.parse(rawPrefill);
		} catch (e) {
			console.warn('Invalid quick request prefill payload', e);
			return;
		}
		if (!payload || String(payload.quick_request) !== '1') return;

		var mapping = [
			{ source: 'full_name', field: 'full_name' },
			{ source: 'phone', field: 'phone' },
			{ source: 'email', field: 'email' },
			{ source: 'confirm_email', field: 'confirm_email' },
			{ source: 'message', field: 'message' }
		];

		mapping.forEach(function(item){
			var value = payload[item.source];
			if (!value) return;
			var input = form.querySelector('[name="' + item.field + '"]');
			if (!input) return;
			input.value = String(value);
		});

		try {
			sessionStorage.removeItem('atl_quick_request_prefill');
		} catch (e) {
			console.warn('Cannot clear quick request prefill', e);
		}

		var errors = validate(form);
		if (Object.keys(errors).length) {
			renderErrors(form, errors);
			form.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}

	function send(form) {
		var data = new FormData(form);
		var phoneInput = form.querySelector('#atl-phone-input');

		if (phoneInput && w.intlTelInputGlobals) {
			var instance = w.intlTelInputGlobals.getInstance && w.intlTelInputGlobals.getInstance(phoneInput);
			if (instance) {
				data.append('phone-full', instance.getNumber());
				var country = instance.getSelectedCountryData();
				if (country) {
					data.append('phone-country-code', '+' + country.dialCode);
					data.append('phone-country-iso', country.iso2);
				}
			}
		}

		// Gửi thêm thông tin IP user nếu đã được detect và cache ở frontend
		try {
			var ipInfo = localStorage.getItem('atl_info_ip');
			if (ipInfo) {
				data.append('dataIpUser', ipInfo);
			}
		} catch (e) {
			console.warn('Cannot access localStorage for IP info', e);
		}

		data.append('action', 'atl_submit_customize_tour');

		var ajaxUrl = (w.atlConfigAjax && w.atlConfigAjax.ajax_url) ? w.atlConfigAjax.ajax_url : '/wp-admin/admin-ajax.php';

		return fetch(ajaxUrl, {
			method: 'POST',
			body: data
		}).then(function(res){ return res.json(); });
	}

	function showFormNotice(form, message, allowHtml) {
		if (w.ATLFormRequest && typeof w.ATLFormRequest.showNoticeModal === 'function') {
			w.ATLFormRequest.showNoticeModal({
				type: 'error',
				message: message,
				allowHtml: !!allowHtml
			});
			return;
		}
		var container = form ? form.querySelector('.atl-form-content') : null;
		if (!container) {
			return;
		}
		var alert = d.createElement('div');
		alert.className = 'alert alert-danger';
		alert.style.marginBottom = '15px';
		if (allowHtml) {
			alert.innerHTML = message;
		} else {
			alert.textContent = message;
		}
		container.insertBefore(alert, container.firstChild);
	}

	/** Ẩn toàn bộ form và chỉ hiển thị panel lỗi hệ thống (giống panel submit thành công). */
	function showBlockedNotice(form, message) {
		var panel = d.querySelector('#atl-customize-tour-error');
		var wrapper = form ? form.closest('.atl_customize_tour_form_wrapper') : null;
		var text = (message && String(message).trim()) ? String(message).trim() : getBlockedMessage();

		setOverlay(form, false);
		clearErrors(form);

		if (!panel) {
			showFormNotice(form, text, true);
			return;
		}

		var messageEl = panel.querySelector('#atl-customize-tour-error-message') || panel.querySelector('.atl-form-blocked-text');
		if (messageEl) {
			// Nội dung do admin cấu hình (đã lọc wp_kses_post ở PHP) — cho phép HTML.
			messageEl.innerHTML = text;
		}

		if (form) {
			form.style.display = 'none';
		}
		if (wrapper) {
			wrapper.style.display = 'none';
		}

		var success = d.querySelector('.atl-customize-success');
		if (success) {
			success.style.display = 'none';
		}

		panel.style.display = 'block';
		panel.removeAttribute('hidden');
		panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}

	function renderErrors(form, errors, message) {
		Object.keys(errors).forEach(function(field){
			var input = null;
			var group = null;
			if (field === 'guide_languages') {
				group = form.querySelector('#atl-guide-languages-group');
				input = form.querySelector('input[name="guide_languages[]"]');
			} else {
				input = form.querySelector('[name="' + field + '"]');
				group = input ? input.closest('.atl_form_group') : null;
			}
			var errorDiv = group ? group.querySelector('.atl-field-error') : null;

			if (!errorDiv && group) {
				errorDiv = d.createElement('div');
				errorDiv.className = 'atl-field-error';
				group.appendChild(errorDiv);
			}

			if (errorDiv) {
				errorDiv.textContent = errors[field];
				errorDiv.style.display = 'block';
				errorDiv.style.color = '#dc3545';
				errorDiv.style.fontSize = '12px';
				errorDiv.style.marginTop = '5px';
			}

			if (input) {
				input.classList.add('atl-field-has-error');
			}
		});

		if (message && !Object.keys(errors).length) {
			showFormNotice(form, message);
		}
	}

	function clearErrors(form) {
		if (w.ATLFormRequest && typeof w.ATLFormRequest.hideNoticeModal === 'function') {
			w.ATLFormRequest.hideNoticeModal();
		}
		form.querySelectorAll('.atl-field-error').forEach(function(el){
			el.textContent = '';
			el.style.display = 'none';
		});
		form.querySelectorAll('.atl_form_control').forEach(function(el){
			el.classList.remove('atl-field-has-error');
		});
		form.querySelectorAll('.alert-danger').forEach(function(el){
			el.remove();
		});
	}

	function attachLiveFieldValidation(form) {
		form.addEventListener('input', function(event){
			if (!event.target || !event.target.name) return;
			clearFieldError(form, event.target.name);
		});

		form.addEventListener('change', function(event){
			if (!event.target || !event.target.name) return;
			clearFieldError(form, event.target.name);
		});
	}

	function clearFieldError(form, fieldName) {
		if (fieldName === 'guide_languages[]' || fieldName.indexOf('guide_languages') === 0) {
			var gGroup = form.querySelector('#atl-guide-languages-group');
			if (!gGroup) return;
			var gErr = gGroup.querySelector('.atl-field-error');
			if (gErr) {
				gErr.textContent = '';
				gErr.style.display = 'none';
			}
			gGroup.querySelectorAll('input[name="guide_languages[]"]').forEach(function(cb){
				cb.classList.remove('atl-field-has-error');
			});
			return;
		}

		var input = form.querySelector('[name="' + fieldName + '"]');
		if (!input) return;

		input.classList.remove('atl-field-has-error');

		var group = input.closest('.atl_form_group');
		if (!group) return;

		var errorDiv = group.querySelector('.atl-field-error');
		if (!errorDiv) return;

		errorDiv.textContent = '';
		errorDiv.style.display = 'none';
	}

	function setButtonLoading(btn, loading) {
		if (!btn) return;
		if (loading) {
			btn._text = btn.textContent;
			btn.disabled = true;
			btn.textContent = 'Sending...';
		} else {
			btn.disabled = false;
			btn.textContent = btn._text || 'START YOUR JOURNEY';
		}
	}

	function setOverlay(form, show) {
		var container = form.closest('.atl_customize_tour_form_wrapper') || form;

		if (!container) return;

		if (getComputedStyle(container).position === 'static') {
			container.style.position = 'relative';
		}

		var overlay = container.querySelector('.atl-form-loading-overlay');
		if (!overlay) {
			overlay = d.createElement('div');
			overlay.className = 'atl-form-loading-overlay';
			overlay.innerHTML = '<div class="atl-loading-pic"><div class="loader"></div></div>';
			container.appendChild(overlay);
		}

		overlay.style.display = show ? 'flex' : 'none';
	}

	function showSuccess(form) {
		var success = d.querySelector('.atl-customize-success');
		var wrapper = form ? form.closest('.atl_customize_tour_form_wrapper') : null;

		if (form) {
			form.style.display = 'none';
		}

		if (success) {
			if (w.atlRevealSuccessWithConsultant) {
				return w.atlRevealSuccessWithConsultant(success).finally(function() {
					if (wrapper) {
						wrapper.style.display = 'none';
					}
					setOverlay(form, false);
				});
			}
			if (wrapper) {
				wrapper.style.display = 'none';
			}
			setOverlay(form, false);
			success.style.display = 'block';
			success.scrollIntoView({ behavior: 'smooth', block: 'start' });
		} else {
			if (wrapper) {
				wrapper.style.display = 'none';
			}
			setOverlay(form, false);
		}
		return Promise.resolve();
	}

	// Google Analytics tracking function
	function trackGoogleAnalytics(requestCode, formData, totalValue) {
		// Check if gtag is available
		if (typeof w.gtag === 'undefined') {
			console.log('Google Analytics gtag not available');
			return;
		}

		// Get user data from stored form data
		var userEmail = formData ? formData.email : '';
		var userPhone = formData ? formData.phone : '';
		
		// Use provided requestCode or empty string
		var finalRequestCode = requestCode || '';
		
		// Use provided totalValue or default to 0
		var finalTotalValue = totalValue !== undefined ? totalValue : 0;
		
		console.log('Tracking Google Analytics conversion:', {
			email: String(userEmail),
			phone: String(userPhone),
			requestCode: String(finalRequestCode),
			totalValue: finalTotalValue
		});

		// Execute custom tracking script from admin settings
		executeCustomTrackingScript(userEmail, userPhone, finalRequestCode, finalTotalValue);
	}

	// Execute custom tracking script from admin settings
	function executeCustomTrackingScript(userEmail, userPhone, requestCode, totalValue) {
		// Check if custom script is available from admin settings
		if (w.atlCustomScripts) {
			var customScript = w.atlCustomScripts.js_after_submit_customize_form || w.atlCustomScripts.page_after_submit_js;
			if (!customScript) {
				return;
			}
			
			// Replace placeholders with actual values, keeping the single quotes
			var scriptToExecute = customScript
				.replace(/'USER_EMAIL'/g, "'" + String(userEmail) + "'")
				.replace(/'USER_PHONE'/g, "'" + String(userPhone) + "'")
				.replace(/'REQUESTCODE'/g, "'" + String(requestCode) + "'")
				.replace(/TOTALVALUE/g, String(totalValue));
			
			console.log('Executing custom tracking script:', scriptToExecute);
			
			try {
				// Execute the custom script
				console.log(scriptToExecute);
				eval(scriptToExecute);
			} catch (error) {
				console.error('Error executing custom tracking script:', error);
			}
		}
	}

	if (d.readyState === 'loading') {
		d.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})(window, document);
